export default [
	{
		start: 0.05,
		end: 2,
		text: 'C\'est inutile...'
	}
]
